var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{attrs:{"title":"Test"}},[_c('a-test-comp-2',{ref:"test-comp-2"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }